import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKraan = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15 7.5h7v1h-7z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M23.5 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
    <path
      fill="#85BDED"
      d="M26.5 31.55c0-1.29 1.69-2.89 2.39-4.62a.12.12 0 0 1 .176-.052.12.12 0 0 1 .044.052c.7 1.73 2.39 3.33 2.39 4.62a2.5 2.5 0 0 1-5 0"
    />
    <path
      fill="#0061CD"
      d="M25.66 13H10.5v8h13.29a1.68 1.68 0 0 1 1.71 1.87V24h7.11v-5.07a5.94 5.94 0 0 0-6-5.93zM13.5 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4M18.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path
      fill="#0061CD"
      d="M16.89 23h3.22a2.39 2.39 0 0 0 2.39-2.39v-7.22A2.39 2.39 0 0 0 20.11 11h-3.22a2.39 2.39 0 0 0-2.39 2.39v7.22A2.39 2.39 0 0 0 16.89 23M6.5 23V11h1.88a1.12 1.12 0 0 1 1.12 1.12v9.76A1.12 1.12 0 0 1 8.38 23zM33.12 28h-8.23a.38.38 0 0 1-.38-.38v-1.58a1.14 1.14 0 0 1 1.13-1.15h6.72a1.14 1.14 0 0 1 1.14 1.14v1.58a.38.38 0 0 1-.38.39"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M14.89 16.39v5.22a1.89 1.89 0 0 0 1.89 1.89H20v1h-3.22a2.89 2.89 0 0 1-2.89-2.89v-5.22z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKraan);

export default ForwardRef;
